module.exports = __webpack_public_path__ + "img/NGC-1976.8c6f0114.jpg";